import request from '@/plugins/request';
import { IBoolResult } from '@/types/dto';
import { IHost, IHostBackup } from '@/types/models';
import utils from '@/utils';
import { AxiosResponse } from 'axios';

const $url = '/admin/backups';

export interface IGetResultItem {
  host: IHost;
  backup: IHostBackup;
}

interface IGetResult {
  items: IGetResultItem[];
}

export default {
  get(success: (res: IGetResult) => void) {
    utils.loading(true);
    request
      .get($url)
      .then((response: AxiosResponse<IGetResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  submit(success: (res: IBoolResult) => void) {
    utils.loading(true);
    request
      .post($url)
      .then((response: AxiosResponse<IBoolResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  delete(backupId: number, success: (res: IBoolResult) => void) {
    utils.loading(true);
    request
      .delete($url, {
        data: {
          backupId,
        },
      })
      .then((response: AxiosResponse<IBoolResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },
};
